import { picturesShape } from "../../shapes";
import DetailsPicture from "../Details/DetailsPicture";
import PictureGallery from "../Pictures/PictureGallery";
import DetailsHeaderItem from "../Details/DetailsHeaderItem";

type Props = {
  pictures?: picturesShape;
  tag?: string;
  typeDisplayName?: string;
};

export default function InstrumentationDetailsBasicInfo({
  pictures,
  tag,
  typeDisplayName,
}: Props) {
  return (
    <>
      <DetailsPicture>
        <PictureGallery
          pictures={pictures}
          placeholder="lcm-iot-icon-instrumentation"
        />
      </DetailsPicture>
      <DetailsHeaderItem
        id="instrumentation-tag"
        translationKey="label.tag"
        value={tag}
      />
      <DetailsHeaderItem
        id="instrumentation-type"
        translationKey="label.type"
        value={typeDisplayName}
      />
    </>
  );
}
